import React from 'react';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import DebtCalculator from '../components/DebtCalculator';
import '../styles/resfi.css';

const CalculatorPage = () => {
  return (
    <div className="landing-page" style={{ background: 'var(--gradient-hero)', minHeight: '100vh' }} data-testid="calculator-page">
      <Nav />
      <div style={{ paddingTop: '3.5rem' }}>
        <DebtCalculator />
      </div>
      <Footer />
    </div>
  );
};

export default CalculatorPage;
